// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"2be3bbb7","188":"01a4b087","197":"ebf126a6","210":"07f09edd","896":"60ee6361","936":"6f6e3f55"}[chunkId] + ".js";
};